import { registerPlugin } from "@capacitor/core";
import { isNativeApp } from "./native.ts";

interface SecureSessionPlugin {
  get(): Promise<{ refreshToken: string | null }>;
  set(options: { refreshToken: string }): Promise<void>;
  clear(): Promise<void>;
}

const secureSession = registerPlugin<SecureSessionPlugin>("SecureSession");

export async function getNativeRefreshToken(): Promise<string | null> {
  if (!isNativeApp()) return null;
  return (await secureSession.get()).refreshToken;
}

export async function saveNativeRefreshToken(token: string | undefined): Promise<void> {
  if (isNativeApp() && token) await secureSession.set({ refreshToken: token });
}

export async function clearNativeRefreshToken(): Promise<void> {
  if (isNativeApp()) await secureSession.clear();
}
